import { Reveal, Overline } from "@/components/Reveal";
import { useLang } from "@/lib/lang";

export default function Method() {
  const { t } = useLang();
  return (
    <section data-testid="method-section" id="metodo" className="bg-alabaster py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <Reveal>
            <Overline>{t.metodo.overline}</Overline>
            <h2 className="mt-4 max-w-xl font-serif text-3xl font-medium tracking-tight text-navy sm:text-4xl lg:text-5xl">
              {t.metodo.title}
            </h2>
          </Reveal>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {t.metodo.steps.map((s, i) => (
            <Reveal key={s.title} delay={0.1 * i}>
              <div data-testid={`method-step-${i + 1}`} className="group relative border-t border-hairline pt-8 transition-colors duration-500 hover:border-gold">
                <span className="absolute -top-px left-0 h-px w-0 bg-gold transition-all duration-700 group-hover:w-full" aria-hidden="true" />
                <p className="font-mono text-[11px] tracking-[0.25em] text-gold-dark">0{i + 1}</p>
                <h3 className="mt-5 font-serif text-2xl font-semibold text-navy">{s.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-ink">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
